import {dataFetcher} from "../../services/dataGuetter/dataFetcher";


export function getNumberModule(id:number):Promise<ModuleFxNumber>{
    return dataFetcher(`module_fx_numbers/${id}`)
}